import React from 'react';
import { contact, socialLinks } from '../data/site';
export function StructuredData() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Australian Flow Batteries',
    alternateName: 'AFB',
    url: contact.siteUrl,
    logo: contact.logo,
    telephone: '+61 1300 426 672',
    email: contact.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: contact.street,
      addressLocality: contact.locality,
      addressRegion: contact.region,
      postalCode: contact.postcode,
      addressCountry: 'AU'
    },
    areaServed: {
      '@type': 'Country',
      name: 'Australia'
    },
    sameAs: [socialLinks.linkedin, socialLinks.youtube],
    description: 'Containerised power systems for remote and critical operations, supporting diesel displacement, microgrids and resilient backup power.'
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(schema)
  }} data-id="element-551" data-mp="7ru2f3454892" />;
}